module.exports = "/static/assets/dbbe6d27575006d24710126e4fb467e0.png";